import { render, staticRenderFns } from "./jianbao.vue?vue&type=template&id=03187e62"
import script from "./jianbao.vue?vue&type=script&lang=js"
export * from "./jianbao.vue?vue&type=script&lang=js"
import style0 from "./jianbao.vue?vue&type=style&index=0&id=03187e62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports